/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardPrizeTier } from './LeaderboardPrizeTier';
import {
    LeaderboardPrizeTierFromJSON,
    LeaderboardPrizeTierFromJSONTyped,
    LeaderboardPrizeTierToJSON,
    LeaderboardPrizeTierToJSONTyped,
} from './LeaderboardPrizeTier';

/**
 * 
 * @export
 * @interface LeaderboardPrizePool
 */
export interface LeaderboardPrizePool {
    /**
     * Sponsor-facing display value (USD or other currency) for prize-based competitions
     * @type {number}
     * @memberof LeaderboardPrizePool
     */
    totalValue?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardPrizePool
     */
    currency?: string;
    /**
     * Guaranteed minimum prize pool in USD dollars. Devour tops the pool up to this figure when entry fees fall short and pays nothing when they cover it — the pool is never less than this, and never this PLUS entry fees. Requires a payoutTableId. Converted to Fuel at distribution time using the Fuel price at payout.
     * @type {number}
     * @memberof LeaderboardPrizePool
     */
    guaranteedPoolUsd?: number;
    /**
     * 
     * @type {Array<LeaderboardPrizeTier>}
     * @memberof LeaderboardPrizePool
     */
    tiers?: Array<LeaderboardPrizeTier>;
}

/**
 * Check if a given object implements the LeaderboardPrizePool interface.
 */
export function instanceOfLeaderboardPrizePool(value: object): value is LeaderboardPrizePool {
    return true;
}

export function LeaderboardPrizePoolFromJSON(json: any): LeaderboardPrizePool {
    return LeaderboardPrizePoolFromJSONTyped(json, false);
}

export function LeaderboardPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'totalValue': json['totalValue'] == null ? undefined : json['totalValue'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(LeaderboardPrizeTierFromJSON)),
    };
}

export function LeaderboardPrizePoolToJSON(json: any): LeaderboardPrizePool {
    return LeaderboardPrizePoolToJSONTyped(json, false);
}

export function LeaderboardPrizePoolToJSONTyped(value?: LeaderboardPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalValue': value['totalValue'],
        'currency': value['currency'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(LeaderboardPrizeTierToJSON)),
    };
}

